module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_null_1@3x.03d4d6fc.png";